module.exports = [{
  name: "Sniper Rifle",
  src: "weapon_1",
  icon: "icon_1",
  sound: "weapon_1",
  animWhileAim: true,
  trail: true,
  flap: {
    src: "flap_0",
    rot: 2.1,
    scl: 1,
    zOff: 0.43,
    xOff: 0.17,
    yOff: 0.53
  },
  noAo: true,
  nAuto: true,
  type: 0,
  scope: true,
  swapTime: 300,
  aimSpeed: 120,
  spdMlt: 0.95,
  ammo: 3,
  reload: 1500,
  dmg: 100,
  pierce: 0.2,
  range: 1000,
  dropStart: 230,
  dmgDrop: 30,
  scale: 0.00115608717587935,
  leftHoldY: -0.7,
  rightHoldY: -0.75,
  leftHoldZ: 2.4,
  rightHoldZ: 0.4,
  xOff: 0.8,
  yOff: -0.68,
  zOff: -1.8,
  xOrg: 0,
  yOrg: -0.55,
  zOrg: -0.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 0.1,
  muzOff: 8,
  muzMlt: 1.6,
  rate: 900,
  spread: 260,
  zoom: 2.7,
  leanMlt: 1.5,
  recoil: 0.009,
  recoilR: 0.02,
  recover: 0.993,
  recoverY: 0.997,
  recoverF: 0.975,
  recoilYM: 0.35,
  recoilZ: 1.4,
  recoilAnim: {
    time: 280,
    aimTime: 500,
    recoilTweenY: 0.2
  },
  jumpYM: 0.15,
  rumble: 0.9,
  rumbleDur: 500
}, {
  name: "Assault Rifle",
  src: "weapon_2",
  icon: "icon_2",
  sound: "weapon_2",
  noAo: true,
  swapWiggle: 0.3,
  attach: 0,
  attachYOff: -0.1,
  attachZOff: -0.8,
  zRot: 1,
  type: 0,
  swapTime: 300,
  aimSpeed: 130,
  spdMlt: 0.95,
  ammo: 30,
  rate: 110,
  reload: 1200,
  dmg: 23,
  pierce: 1,
  range: 700,
  dmgDrop: 5,
  scale: 0.00095745145728643,
  leftHoldY: -0.45,
  rightHoldY: -0.6,
  leftHoldZ: 0.65,
  rightHoldZ: -1.3,
  xOff: 1,
  yOff: -0.7,
  yRot: 0.0018,
  zOff: -3.6,
  xOrg: 0,
  yOrg: -0.625,
  zOrg: -2.3,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 1.5,
  caseZOff: -1.7,
  caseYOff: -0.2,
  muzOff: 5.1,
  muzOffY: -0.05,
  muzMlt: 1.4,
  spread: 100,
  minSpread: 5,
  zoom: 1.6,
  leanMlt: 1.5,
  recoil: 0.003,
  recoilR: 0.02,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 0.32,
  recoilZ: 5,
  recoilZM: -0.05,
  aimRecMlt: 0.8,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.05
  },
  jumpYM: 0.6,
  rumble: 0.5
}, {
  name: "Pistol",
  src: "weapon_3",
  icon: "icon_3",
  sound: "weapon_3",
  secondary: true,
  noAo: true,
  transp: true,
  nAuto: true,
  kill: ["", 75],
  swapWiggle: 0.3,
  type: 1,
  shine: 10,
  swapTime: 350,
  aimSpeed: 120,
  spdMlt: 1.05,
  ammo: 10,
  reload: 700,
  dmg: 20,
  range: 700,
  dmgDrop: 10,
  scale: 0.0003158947055276376,
  leftHoldY: -1.1,
  rightHoldY: -0.62,
  leftHoldZ: -0.55,
  rightHoldZ: -0.5,
  xOff: 0.7,
  yOff: -0.6,
  zOff: -3.7,
  xOrg: 0,
  yRot: -0.005,
  yOrg: -0.23,
  zOrg: -3.9,
  jYMlt: 0.1,
  cLean: 0.3,
  cRot: 0.3,
  caseZOff: 0.2,
  caseYOff: 0,
  inspectR: 0.3,
  inspectM: 0.8,
  muzOff: 1.5,
  muzOffY: 0,
  muzMlt: 0.95,
  rate: 150,
  spread: 90,
  zoom: 1.4,
  leanMlt: 1,
  recoil: 0.006,
  recoilR: 0.01,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  aimRecMlt: 0.4,
  recoilZ: 3.6,
  recoilZM: -0.4,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.2
  },
  rumble: 0.4
}, {
  name: "Submachine Gun",
  src: "weapon_4",
  icon: "icon_4",
  sound: "weapon_4",
  swapWiggle: 0.5,
  attach: 0,
  attachYOff: -0.09,
  attachZOff: -1.1,
  zRot: 0.75,
  noAo: true,
  type: 0,
  swapTime: 300,
  aimSpeed: 120,
  spdMlt: 1.04,
  ammo: 24,
  reload: 1000,
  dmg: 18,
  pierce: 1,
  range: 700,
  dmgDrop: 12,
  scale: 0.000574897587939697,
  leftHoldY: -0.4,
  leftHoldX: -0.1,
  rightHoldY: -0.5,
  leftHoldZ: 1.1,
  rightHoldZ: -0.95,
  xOff: 0.85,
  yOff: -0.86,
  zOff: -3,
  xOrg: 0,
  yOrg: -0.59,
  zOrg: -2.5,
  cRot: 0.18,
  cLean: 0.16,
  inspectR: 0.2,
  inspectM: 1.2,
  caseYOff: -0.15,
  caseZOff: -0.4,
  muzOff: 2.15,
  muzOffY: 0.1,
  rate: 90,
  spread: 70,
  minSpread: 5,
  zoom: 1.65,
  jYMlt: 0.8,
  leanMlt: 1,
  recoil: 0.0034,
  recoilY: 0.77,
  recoilR: 0.02,
  recover: 0.975,
  recoverY: 0.996,
  recoverF: 0.975,
  recoilZ: 3.2,
  recoilZM: -0.1,
  aimRecMlt: 0.7,
  recoilAnim: {
    time: 200,
    recoilTweenYM: 0.05,
    recoilTweenY: 0.06
  },
  expScale: 0.8,
  rumble: 0.4
}, {
  name: "Revolver",
  src: "weapon_5",
  icon: "icon_5",
  sound: "weapon_5",
  nAuto: true,
  nCase: true,
  transp: true,
  kill: ["", 50],
  type: 0,
  swapTime: 200,
  aimSpeed: 120,
  spdMlt: 1.04,
  ammo: 6,
  reload: 900,
  dmg: 66,
  pierce: 0.85,
  dmgDrop: 10,
  scale: 1.3,
  leftHoldY: -1.1,
  rightHoldY: -0.8,
  leftHoldZ: -0.5,
  rightHoldZ: -0.5,
  xOff: 0.7,
  yOff: -0.7,
  zOff: -4.1,
  xOrg: 0,
  yOrg: -0.31,
  zOrg: -3.8,
  jYMlt: 0.5,
  cLean: 0.5,
  cRot: 0.4,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 0.3,
  muzOff: 2.75,
  muzOffY: 0.2,
  muzMlt: 0.95,
  range: 700,
  rate: 390,
  spread: 100,
  zoom: 1.4,
  leanMlt: 1.6,
  recoil: 0.013,
  recoilR: 0.035,
  recover: 0.982,
  recoverY: 0.992,
  recoverF: 0.98,
  recoilYM: 0.2,
  aimRecMlt: 0.6,
  recoilZM: -1.4,
  recoilZ: 2,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.4
  },
  expScale: 0.9,
  rumble: 0.7
}, {
  name: "Shotgun",
  src: "weapon_6",
  icon: "icon_6",
  sound: "weapon_6",
  noAo: true,
  nAuto: true,
  nCase: true,
  transp: true,
  nRing: true,
  swapWiggle: 0.4,
  shine: 35,
  type: 0,
  physRang: 35,
  physPow: 0.085,
  swapTime: 300,
  aimSpeed: 120,
  spdMlt: 1,
  ammo: 2,
  shots: 5,
  reload: 1100,
  dmg: 50,
  dmgDrop: 50,
  scale: 0.00082934281407035,
  rightHoldX: 0.1,
  leftHoldY: -0.5,
  rightHoldY: -0.7,
  leftHoldZ: 0.4,
  rightHoldZ: -1.5,
  xOff: 0.95,
  yOff: -0.65,
  zOff: -3.8,
  xOrg: 0,
  yOrg: -0.3,
  zOrg: -2.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  jYMlt: 0.2,
  inspectR: 0.1,
  inspectM: 1.9,
  muzOff: 6,
  muzMlt: 1.8,
  range: 240,
  rate: 400,
  innac: 110,
  spread: 120,
  minSpread: 20,
  zoom: 1.25,
  leanMlt: 1.6,
  recoil: 0.016,
  recoilR: 0.015,
  recover: 0.99,
  recoverF: 0.97,
  recoilZ: 2,
  recoilZM: 0.2,
  aimRecMlt: 0.5,
  recoilYM: 0.6,
  recoilAnim: {
    time: 340,
    recoilTweenY: 0.2
  },
  jumpYM: 0.5,
  rumble: 0.8
}, {
  name: "Light Machine Gun",
  src: "weapon_7",
  icon: "icon_7",
  sound: "weapon_7",
  type: 0,
  attach: 0,
  swapWiggle: 0.3,
  attachYOff: -0.085,
  attachZOff: -0.7,
  zRot: 0.75,
  noAo: true,
  swapTime: 700,
  aimSpeed: 200,
  spdMlt: 0.79,
  ammo: 60,
  reload: 3500,
  dmg: 20,
  pierce: 1,
  range: 700,
  dmgDrop: 10,
  jYMlt: 0.8,
  scale: 0.0008856008924623108,
  leftHoldY: -0.85,
  leftHoldX: 0.4,
  rightHoldY: -0.75,
  leftHoldZ: 1.1,
  rightHoldZ: -0.2,
  yRot: -0.01,
  xOff: 0.95,
  yOff: -0.75,
  zOff: -2.8,
  xOrg: 0,
  yOrg: -0.6,
  zOrg: -1.8,
  cLean: 0.1,
  cRot: 0.1,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 0.6,
  caseInd: 2,
  caseZOff: -0.5,
  caseYOff: -0.1,
  muzOff: 5.5,
  muzOffY: -0.14,
  muzMlt: 1.7,
  rate: 120,
  spread: 300,
  minSpread: 10,
  zoom: 1.3,
  leanMlt: 1.6,
  recoil: 0.0032,
  recoilR: 0.014,
  recover: 0.98,
  recoverY: 0.9975,
  recoverF: 0.975,
  recoilZ: 3.8,
  recoilYM: 0.25,
  recoilZ: 3,
  recoilZM: -0.1,
  aimRecMlt: 0.5,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.03
  },
  jumpYM: 0.5,
  expScale: 0.85,
  rumble: 0.65
}, {
  name: "Semi Auto",
  src: "weapon_8",
  icon: "icon_8",
  sound: "weapon_8",
  attach: 0,
  attachYOff: -0.08,
  attachZOff: -1.55,
  nAuto: true,
  zRot: 0.7,
  type: 0,
  noAo: true,
  swapWiggle: 0.4,
  swapTime: 300,
  aimSpeed: 120,
  spdMlt: 1,
  ammo: 8,
  reload: 1500,
  dmg: 34,
  pierce: 0.2,
  range: 1000,
  dmgDrop: 0,
  scale: 0.00093686221105528,
  leftHoldY: -0.5,
  rightHoldY: -0.45,
  leftHoldZ: 0.4,
  rightHoldZ: -1.85,
  jYMlt: 0.9,
  xOff: 0.8,
  yOff: -0.55,
  zOff: -3.5,
  xOrg: 0,
  yOrg: -0.395,
  yRot: -0.005,
  zOrg: -3.4,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.2,
  inspectM: 1.4,
  muzOff: 4,
  muzOffY: -0.05,
  muzMlt: 1.1,
  rate: 120,
  spread: 250,
  caseZOff: -1.3,
  zoom: 2.1,
  recoil: 0.01,
  recoilR: 0.012,
  recover: 0.98,
  recoilY: 0.36,
  recoverY: 0.994,
  recoverF: 0.975,
  recoilYM: 0.6,
  recoilZ: 2,
  recoilZM: 0.2,
  aimRecMlt: 0.8,
  recoilAnim: {
    time: 250,
    recoilTweenY: 0.11
  },
  jumpYM: 0.5,
  rumble: 0.75
}, {
  name: "Rocket Launcher",
  src: "weapon_9",
  icon: "icon_9",
  sound: "weapon_9",
  nInsp: true,
  nSkill: true,
  nAuto: true,
  nCase: true,
  nRing: true,
  noAo: true,
  projectile: 0,
  type: 0,
  swapTime: 400,
  swapWiggle: 0.4,
  aimSpeed: 200,
  spdMlt: 0.9,
  ammo: 1,
  reload: 1600,
  scale: 0.00076263407035176,
  leftHoldX: -0.1,
  leftHoldY: -0.36,
  rightHoldY: -0.3,
  leftHoldZ: 1.2,
  rightHoldX: -0.15,
  rightHoldZ: -0.2,
  jYMlt: 0.4,
  xOff: 0.95,
  yOff: -0.56,
  zOff: -2.6,
  xOrg: 0,
  yOrg: -0.945,
  zOrg: -3,
  zRot: 0.9,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  muzOff: 5,
  muzOffY: 0,
  muzMlt: 1.5,
  rate: 1,
  spread: 120,
  minSpread: 15,
  zoom: 1.5,
  leanMlt: 1.4,
  landBob: 0.8,
  recoil: 0.008,
  recoilR: 0.012,
  recover: 0.99,
  recoverY: 0.998,
  recoverF: 0.975,
  recoilZ: 4,
  recoilZM: -0.5,
  aimRecMlt: 0.9,
  recoilAnim: {
    time: 400,
    recoilTweenY: 0.25
  },
  jumpYM: 0.3,
  expScale: 0.7,
  rumble: 1,
  rumbleDur: 750
}, {
  name: "Akimbo Uzi",
  src: "weapon_10",
  icon: "icon_10",
  sound: "weapon_10",
  nInsp: true,
  noAim: true,
  akimbo: true,
  type: 0,
  swapTime: 300,
  aimSpeed: 120,
  spdMlt: 1.04,
  ammo: 18,
  reload: 1200,
  dmg: 18,
  pierce: 1,
  range: 700,
  dmgDrop: 12,
  scale: 0.9,
  rightHoldY: -0.55,
  leftHoldZ: 0.3,
  leftHoldX: -0.25,
  leftHoldY: -0.55,
  rightHoldZ: 0.3,
  rightHoldX: -0.25,
  holdW: 1.3,
  xOff: 1.5,
  yOff: -0.95,
  zOff: -3.3,
  xOrg: 0,
  yOrg: -0.62,
  zOrg: -2.5,
  zLnM: 0.4,
  cLean: 0.1,
  cRot: 0.1,
  cDrop: 0.2,
  caseYOff: -0.15,
  caseZOff: -0.4,
  muzOff: 3.6,
  rate: 60,
  spread: 40,
  spreadInc: 1.5,
  minSpread: 10,
  zoom: 1.5,
  leanMlt: 0.6,
  recoil: 0.0034,
  recoilR: 0.015,
  recover: 0.978,
  recoverY: 0.996,
  recoverF: 0.975,
  recoilZ: 5,
  recoilYM: 0.6,
  recoilAnim: {
    recoilTweenY: 0.01
  },
  expScale: 0.7,
  rumble: 0.4
}, {
  name: "Desert Eagle",
  src: "weapon_11",
  icon: "icon_11",
  sound: "weapon_11",
  secondary: true,
  minRec: 15,
  nAuto: true,
  noAo: true,
  transp: true,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpeed: 120,
  spdMlt: 1,
  ammo: 6,
  reload: 1000,
  dmg: 50,
  pierce: 0.85,
  dmgDrop: 10,
  scale: 0.94,
  leftHoldY: -0.9,
  rightHoldY: -0.7,
  leftHoldZ: -0.5,
  rightHoldZ: -0.5,
  holdW: 0.95,
  xOff: 1,
  yOff: -0.7,
  zOff: -4.1,
  xOrg: 0,
  yOrg: -0.195,
  zOrg: -3.8,
  cLean: 0.3,
  cRot: 0.3,
  inspectR: 0.35,
  inspectM: 0.9,
  muzOff: 2,
  muzMlt: 1.1,
  range: 700,
  rate: 400,
  spread: 150,
  jYMlt: 0.5,
  zoom: 1.4,
  leanMlt: 1.6,
  recoil: 0.01,
  recoilR: 0.01,
  recover: 0.985,
  recoverY: 0.996,
  recoverF: 0.98,
  recoilYM: 0.4,
  aimRecMlt: 0.5,
  recoilZ: 2.5,
  recoilZM: 0.2,
  recoilAnim: {
    time: 290,
    recoilTweenY: 0.35
  },
  rumble: 0.8
}, {
  name: "Alien Blaster",
  src: "weapon_13",
  icon: "icon_13",
  sound: "weapon_13",
  secondary: true,
  nRing: true,
  nAuto: true,
  transp: true,
  nCase: true,
  minRec: 50,
  kill: ["", 50],
  type: 1,
  swapTime: 200,
  aimSpeed: 120,
  spdMlt: 1,
  ammo: 4,
  reload: 1500,
  dmg: 50,
  pierce: 0.85,
  dmgDrop: 10,
  scale: 1.1,
  leftHoldY: -1,
  rightHoldY: -0.65,
  leftHoldZ: -0.2,
  rightHoldZ: -0.2,
  xOff: 1.3,
  yOff: -0.83,
  zOff: -4.1,
  xOrg: 0,
  yRot: -0.01,
  yOrg: -0.53,
  zOrg: -3.8,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0,
  inspectR: 0.1,
  inspectM: 0.8,
  holdW: 0.7,
  muzOff: 2.2,
  muzOffY: 0.1,
  muzID: 3,
  muzMlt: 1.1,
  jYMlt: 0.8,
  range: 700,
  rate: 150,
  spread: 150,
  zoom: 1.4,
  leanMlt: 1.6,
  recoil: 0.006,
  recoilR: 0.01,
  recover: 0.98,
  recoverY: 0.99,
  recoverF: 0.98,
  recoilYM: 0.2,
  recoilZ: 2,
  aimRecMlt: 0.6,
  recoilAnim: {
    time: 200,
    recoilTweenY: 0.3
  },
  rumble: 0.4
}, {
  name: "Combat Knife",
  icon: "icon_0",
  melee: true,
  nInsp: true,
  noSkins: true,
  holdW: 0.9,
  swapWiggle: 0.3,
  sounds: ["swish_0", "swish_1"],
  noAim: true,
  anim: function (bqi, bqj, bqm) {
    if (bqm == 1) {
      bqi.handAnimInd = (bqi.handAnimInd || 1) * -1;
      var bqn = false;
      if (bqi.meleeAnim.anim) {
        bqi.meleeAnim.anim.stop();
        bqn = bqi.meleeAnim.armM >= 2;
      }
      bqi.resetMeleeAnim();
      var bqo = -1.2;
      var bqp = 0.7;
      var bqq = -0.4;
      if (bqn) {
        bqo += 0.1;
        bqi.meleeAnim.weaR = bqo;
        bqq += 0.8;
        bqi.meleeAnim.armR = bqq;
        bqp += 0.2;
        bqi.meleeAnim.weaM = bqp;
        bqi.meleeAnim.flipW = Math.PI;
      } else {
        bqo -= 0.4;
      }
      bqi.meleeAnim.anim = new bqj.Tween(bqi.meleeAnim).to({
        armR: bqq,
        lArm: 1,
        armT: bqn ? -0.2 : -0.8,
        armY: -3,
        armM: bqn ? -10 : 13,
        armE: -2,
        weaR: bqo,
        weaM: bqp
      }, (bqn ? 1.3 : 1) * 220).easing(bqj.Easing.Cubic.Out).onComplete(function () {
        bqi.meleeAnim.anim = new bqj.Tween(bqi.meleeAnim).to({
          armR: 0,
          armT: 0,
          armY: 0,
          lArm: 0,
          armM: 0,
          armE: 0,
          weaR: 0,
          weaM: 0,
          flipW: 0
        }, 350).easing(bqj.Easing.Cubic.Out).start();
      }).start();
    } else {
      bqi.handAnimInd = (bqi.handAnimInd || 1) * -1;
      var bqr = (bqi.handAnimInd == 1 ? "l" : "r") + "HndTween";
      if (bqi[bqr]) {
        bqi[bqr].stop();
      }
      bqi[bqr + "A"] = bqi[bqr + "A"] || 0;
      bqi[bqr] = new bqj.Tween(bqi).to({
        [bqr + "A"]: 2.4
      }, 30).easing(bqj.Easing.Linear.None).onComplete(function () {
        bqi[bqr] = new bqj.Tween(bqi).to({
          [bqr + "A"]: 0
        }, 200).easing(bqj.Easing.Linear.None).delay(100).start();
      }).start();
    }
  },
  type: 1,
  swapTime: 350,
  aimSpeed: 120,
  rate: 250,
  dmg: 50,
  dmgDrop: 0,
  range: 15,
  spdMlt: 1.1,
  spread: 100,
  leftHoldY: -0.82,
  leftHoldX: 1.5,
  rightHoldX: -1.5,
  rightHoldY: -0.82,
  leftHoldZ: -0.5,
  rightHoldZ: -0.5,
  xOff: 0,
  yOff: -0.6,
  zOff: -3.6,
  xOrg: 0.5,
  yOrg: 0,
  zOrg: -3.6,
  zRM: 0.35,
  zoom: 1,
  leanMlt: 0.8,
  recoil: 0.006,
  recoilR: 0.01,
  recover: 0.98,
  recoverF: 0.98,
  rumble: 1
}, {
  name: "Crossbow",
  src: "weapon_17",
  icon: "icon_17",
  sound: "weapon_17",
  noSkins: true,
  nInsp: true,
  nRing: true,
  nAuto: true,
  noAo: true,
  nCase: true,
  nMuz: true,
  attach: 0,
  attachYOff: -0.1,
  attachZOff: 0.65,
  kill: ["", 100],
  type: 0,
  projectile: 1,
  swapTime: 200,
  aimSpeed: 120,
  spdMlt: 1,
  ammo: 1,
  reload: 1000,
  dmg: 100,
  pierce: 0,
  dmgDrop: 0,
  scale: 0.0007303348040201011,
  leftHoldY: -0.33,
  rightHoldY: -0.28,
  leftHoldZ: 2.2,
  leftHoldX: 0,
  rightHoldZ: 0.9,
  xOff: 1.3,
  yOff: -0.95,
  zOff: -1.9,
  xOrg: 0,
  yOrg: -0.72,
  zOrg: -1,
  cLean: 0.1,
  cRot: 0.1,
  zRot: 0.9,
  cDrop: 0.2,
  holdW: 0.5,
  muzOff: 2.2,
  muzOffY: 0.1,
  muzID: 3,
  muzMlt: 1.1,
  jYMlt: 0.95,
  range: 700,
  rate: 150,
  spread: 300,
  zoom: 1.4,
  leanMlt: 0.3,
  recoil: 0.007,
  recoilR: 0.01,
  recover: 0.985,
  recoverY: 0.996,
  recoverF: 0.98,
  recoilZ: 4,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.1
  },
  rumble: 0.5
}, {
  name: "Famas",
  src: "weapon_18",
  icon: "icon_18",
  sound: "weapon_18",
  noAo: true,
  nAuto: true,
  burst: {
    c: 3,
    r: 90
  },
  swapWiggle: 0.6,
  attach: 0,
  attachYOff: -0.1,
  attachZOff: -0.5,
  zRot: 1,
  type: 0,
  swapTime: 300,
  aimSpeed: 130,
  spdMlt: 0.95,
  ammo: 30,
  rate: 300,
  reload: 1200,
  dmg: 28,
  pierce: 1,
  range: 700,
  dmgDrop: 5,
  scale: 0.0008858419597989991,
  leftHoldY: -0.45,
  rightHoldY: -0.5,
  leftHoldZ: 0.72,
  rightHoldZ: -1,
  xOff: 1,
  yOff: -0.86,
  yRot: 0.0018,
  zOff: -3,
  xOrg: 0,
  yOrg: -1.14,
  zOrg: -2,
  cLean: 0.2,
  cRot: 0.2,
  cDrop: 0.1,
  inspectR: 0.1,
  inspectM: 1.5,
  caseZOff: -1.7,
  caseYOff: -0.2,
  muzOff: 4.9,
  muzOffY: -0.05,
  muzMlt: 1.4,
  spread: 90,
  minSpread: 5,
  zoom: 1.5,
  leanMlt: 1.5,
  recoil: 0.0032,
  recoilR: 0.02,
  recover: 0.978,
  recoverY: 0.995,
  recoverF: 0.975,
  jYMlt: 0.9,
  recoilYM: 0.32,
  recoilZ: 5,
  recoilZM: 0.05,
  aimRecMlt: 0.8,
  recoilAnim: {
    time: 300,
    recoilTweenY: 0.05
  },
  jumpYM: 0.6,
  rumble: 0.5
}];
module.exports.findWeaponBySrc = function (bqj) {
  for (var bqt = 0; bqt < module.exports.length; ++bqt) {
    if (module.exports[bqt].src == "weapon_" + bqj) {
      return module.exports[bqt];
    }
  }
  return null;
};